






import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class RenderOrderStatus extends Vue {
  @Prop() private value!: string;

  private states: { [key: string]: string } = {
    'canceled': 'لغو شده',
    'pending': 'در انتظار',
    'processing': 'در حال پردازش',
    'complete': 'تکمیل شده',
  };

  public getValue(): string {
    return this.states[this.value];
  }
}
